import React from "react";

const RecommendationItem = ({ item }) => {

  // Group with subItems
  if (item.subItems) {
    return (
      <div className="mb-3">
        {item.title && <h5>{item.title}</h5>}
        <ul>
          {item.subItems.map((subItem, i) => (
            <li key={i}>
              {subItem.title && <strong>{subItem.title}</strong>}
              {subItem.text && <p className="mb-1">{subItem.text}</p>}

              {subItem.details && (
                <ul>
                  {subItem.details.map((detail, j) => (
                    <li key={j}>{detail}</li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className={`mb-3 recommendation-item ${item.type}`}>
      {item.title && <h5>{item.title}</h5>}
      {item.text && <p>{item.text}</p>}

      {item.items && (
        <ul>
          {item.items.map((listItem, i) => (
            <li key={i}>{listItem}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RecommendationItem;
